<template>
  <generic-modal :title="$t('product')" ref="generic_modal" :is_wide="true">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
      <div class="column is-one-fifth">
        <div class="field">
          <label class="label">{{ $t("type") }}</label>
          <div class="select">
            <select class="input" v-model="meta.type">
              <option value="simple">{{ $t("simple") }}</option>
              <option value="variable">{{ $t("variable") }}</option>
              <option value="grouped">{{ $t("grouped") }}</option>
              <option value="external">{{ $t("external") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("sku") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.sku" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("price") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.regular_price" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("status") }}</label>
          <div class="select">
            <select class="input" v-model="meta.status">
              <option value="publish">{{ $t("publish") }}</option>
              <option value="draft">{{ $t("draft") }}</option>
              <option value="pending">{{ $t("pending") }}</option>
              <option value="private">{{ $t("private") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-three-fifths">
        <div class="field">
          <label class="label">{{ $t("permalink") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.permalink" />
          </div>
        </div>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("description") }}</label>
      <div class="control">
        <textarea
          class="textarea"
          rows="2"
          v-model="meta.description"
        ></textarea>
      </div>
    </div>

    <div class="title is-5 mt-5">{{ $t("stock") }}</div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="manage_stock"
            v-model="meta.manage_stock"
          />
          <label for="manage_stock">{{ $t("manage stock") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("stock status") }}</label>
          <div class="select">
            <select class="input" v-model="meta.stock_status">
              <option value="instock">{{ $t("in stock") }}</option>
              <option value="outofstock">{{ $t("out of stock") }}</option>
              <option value="onbackorder">{{ $t("on back order") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("stock quantity") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.stock_quantity" />
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <p class="buttons is-pulled-right">
        <button class="button is-secondary is-rounded" @click="add_attribute">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </p>
      <h5 class="title is-5 pt-3">{{ $t("attributes") }}</h5>
      <table
        class="table is-bordered is-fullwidth"
        v-if="meta && meta.attributes"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("values") }}</th>
            <th>{{ $t("miscellaneous") }}</th>
            <th>{{ $t("options") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rsrc, ridx) in meta.attributes" :key="ridx">
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.attributes[ridx].name"
              />
            </td>
            <td>
              <div class="tags">
                <span
                  class="tag is-info"
                  v-for="(option, oidx) in meta.attributes[ridx].options"
                  :key="oidx"
                >
                  <input
                    type="text"
                    class="input"
                    v-model="meta.attributes[ridx].options[oidx]"
                  />
                  <button
                    class="delete is-small"
                    @click="meta.attributes[ridx].options.splice(oidx, 1)"
                  ></button>
                </span>
              </div>
              <button
                class="button is-small is-success"
                @click="meta.attributes[ridx].options.push($t('new value'))"
              >
                <span class="icon">
                  <i class="fa fa-plus"></i>
                </span>
              </button>
            </td>
            <td>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_is_visible' + ridx"
                  v-model="meta.attributes[ridx].visible"
                />
                <label :for="'chk_is_visible' + ridx">{{
                  $t("visible in products page")
                }}</label>
              </div>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_variation' + ridx"
                  v-model="meta.attributes[ridx].variation"
                />
                <label :for="'chk_variation' + ridx">{{
                  $t("used for variations")
                }}</label>
              </div>
            </td>
            <td>
              <button
                class="button is-secondary has-text-danger is-rounded"
                @click="meta.attributes.splice(ridx, 1)"
                :data-tooltip="$t('delete')"
              >
                <span class="icon">
                  <i class="fa fa-trash"></i>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded is-primary" @click="save_order">
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "WooCommerceEditProductModal",
  components: { GenericModal, VLazyImage },
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  props: {},
  computed: {},
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/woocommerce/product", { uuid: uuid })
        .then((product) => {
          v.meta = product.json_data;
          v.meta.mdl_uuid = uuid;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    create_modal() {
      let v = this;
      v.set_initial_state();
      v.set_default_product_values();
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
    set_default_product_values() {
      let v = this;
      v.meta = {
        sku: "",
        name: v.$t("new product"),
        type: "",
        regular_price: "",
        images: [],
        status: "",
        weight: "",
        on_sale: true,
        virtual: false,
        featured: false,
        downloads: [],
        attributes: [],
        backorders: "no",
        categories: [
          // {
          //   id: 264,
          //   name: "Sin categorizar",
          //   slug: "sin-categorizar",
          // },
        ],
        manage_stock: true,
        stock_status: "instock",
        stock_quantity: 0,
      };
    },
    save_order() {
      let v = this;
      v.$root.loader(true);
      let data = { ...v.meta };

      if (data.mdl_uuid) {
        post("/woocommerce/product", data)
          .then((order) => {
            v.$emit("order_updated");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      } else {
        put("/woocommerce/product", data)
          .then((order) => {
            v.$emit("order_updated");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      }
    },
    add_attribute() {
      let v = this;
      if (!v.meta.attributes) {
        v.meta.attributes = [];
      }
      v.meta.attributes.push({
        name: "",
        options: [],
        visible: false,
        variation: false,
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
